<app-side-menu>
  <div class="b2b-contracts-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              <h1 class="page-title">
                <i class="fas fa-file-contract me-3"></i>
                Gestão de Contratos B2B
              </h1>
              <p class="page-subtitle">
                Gerencie os contratos B2B com prestadores de serviço externos e parceiros.
              </p>
            </div>
            <app-button
              *appHasPermission="'B2BContracts.Create'"
              text="Novo Contrato"
              color="var(--success-color)"
              (buttonClick)="newContract()"
              className="new-contract-btn">
              <i class="fas fa-plus me-2"></i>
            </app-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="filters-card">
          <div class="row g-3">
            <div class="col-md-6">
              <div class="filter-group">
                <label for="searchTerm">Busca Livre:</label>
                <input
                  type="text"
                  id="searchTerm"
                  [(ngModel)]="searchTerm"
                  (ngModelChange)="onSearchChange($event)"
                  placeholder="Buscar por número, motorista, CPF/CNPJ, placa, veículo..."
                  class="form-control">
              </div>
            </div>
            <div class="col-md-6">
              <div class="filter-group">
                <label for="selectedStatus">Status:</label>
                <select
                  id="selectedStatus"
                  [(ngModel)]="selectedStatus"
                  (ngModelChange)="onStatusChange()"
                  class="form-control">
                  <option *ngFor="let option of statusOptions" [value]="option.value">
                    {{ option.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div class="row">
      <div class="col-12">
        <div class="contracts-card">
          <!-- Loading -->

          <!-- Estado vazio -->
          <div *ngIf="!contracts || contracts.length === 0 && !isLoading" class="empty-state">
            <i class="fas fa-file-contract"></i>
            <h3>Nenhum contrato encontrado</h3>
            <p>Cadastre seu primeiro contrato B2B para começar a gerenciar.</p>
            <app-button
              text="Cadastrar Primeiro Contrato"
              color="var(--primary-color)"
              (buttonClick)="newContract()"
              className="btn-primary">
              <i class="fas fa-plus me-2"></i>
            </app-button>
          </div>

          <!-- Tabela -->
          <div *ngIf="isLoading || (contracts && contracts.length > 0)" class="contracts-table">
            <div class="table-header">
              <h3 class="table-title">
                <i class="fas fa-list me-2"></i>
                Lista de Contratos
              </h3>
              <p class="mb-0 text-muted">
                Total de {{ totalItems || contracts.length }} contrato{{ (totalItems || contracts.length) !== 1 ? 's' : '' }}
              </p>
            </div>

            <div class="table-content">
              <app-table
                [title]="'Contratos B2B'"
                [data]="contracts"
                [columns]="columns"
                [loading]="isLoading"
                [clickable]="true"
                [visibleActions]="visibleActions"
                [actions]="actions"
                [useDropdownMenu]="true"
                [totalItemsFromBackend]="totalItems"
                [showSearch]="false"
                (rowClick)="view($event)"
                (actionClick)="onActionClick($event)"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)">
              <app-button
                table-header-action
                text="Exportar Excel"
                color="var(--success-color)"
                height="36px"
                [disabled]="!contracts || contracts.length === 0"
                (buttonClick)="exportExcel()">
                <i class="fas fa-file-excel me-2"></i>
              </app-button>
              </app-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-modal
      [isOpen]="showCancelModal"
      [title]="'Cancelar Contrato B2B'"
      [size]="'md'"
      [closable]="true"
      (close)="closeCancelModal()">

      <div class="py-2">
        <div class="alert alert-warning mb-3">
          <i class="fa-solid fa-exclamation-triangle me-2"></i>
          O contrato será cancelado e as cobranças pendentes serão canceladas.
        </div>

        <div class="mb-3">
          <label for="b2bListCancelReasonCode" class="form-label">
            Motivo do cancelamento <span class="text-danger">*</span>
          </label>
          <select
            id="b2bListCancelReasonCode"
            class="form-select"
            [(ngModel)]="cancelReasonCode"
            name="b2bListCancelReasonCode">
            <option [ngValue]="''">Selecione um motivo</option>
            <option *ngFor="let o of contractCancelReasonOptions" [ngValue]="o.code">{{ o.label }}</option>
          </select>
          <small class="text-muted d-block mt-1">O texto é gravado nas observações do contrato B2B (linha de cancelamento).</small>
        </div>

        <p class="mb-0">
          <strong>Confirma o cancelamento do contrato {{ getContractNumberToCancel() }}?</strong>
        </p>
      </div>

      <div slot="footer" class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" (click)="closeCancelModal()" [disabled]="isLoading">
          Fechar
        </button>
        <button type="button" class="btn btn-danger" (click)="confirmCancelContract()" [disabled]="isLoading">
          Confirmar Cancelamento
        </button>
      </div>
    </app-modal>

    <app-contract-freeze-modal
      [isOpen]="showFreezeModal"
      [contractId]="contractFreezeId"
      [subtitle]="contractFreezeSubtitle"
      (closed)="closeFreezeModal()"
      (frozen)="onContractFrozen($event)">
    </app-contract-freeze-modal>
  </div>
</app-side-menu>


